/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.1.0
 */

import moment, { Moment } from 'moment';

import { IMonthPickerPresets } from '../../../modules/internationalization/types/common/calendar';
import { LayoutStyled } from '../Block/Layout';
import { RangeMonthPickerLinkStyled } from './styled/RangeMonthPickerStyled';

export interface IRangeMonthPickerPresets {
    setRange: (a: Moment, b: Moment) => void;
    translation: IMonthPickerPresets;
}

const RangeMonthPickerPresets = (props: IRangeMonthPickerPresets) => {
    return <>
        <LayoutStyled className="mb-3">
            <RangeMonthPickerLinkStyled
                data-name='presetMonth'
                onClick={() => props.setRange(moment().startOf('month'), moment())}>
                {props.translation.period}
            </RangeMonthPickerLinkStyled>
        </LayoutStyled>
        <LayoutStyled className="mb-3">
            <RangeMonthPickerLinkStyled
                data-name='presetQuarter'
                onClick={() => props.setRange(moment().add(-2, 'month').startOf('month'), moment())}>
                {props.translation.quarter}
            </RangeMonthPickerLinkStyled>
        </LayoutStyled>
        <LayoutStyled className="mb-3">
            <RangeMonthPickerLinkStyled
                data-name='presetYear'
                onClick={() => props.setRange(moment().startOf('year'), moment())}>
                {props.translation.startYear}
            </RangeMonthPickerLinkStyled>
        </LayoutStyled>
    </>;
};

export default RangeMonthPickerPresets;
